export default {
    title: "주문번호 상세 내역",
    product_name: "상품항목",
    custom_content: "보상 내역",
    game_name: "게임",
    server_name: "서버",
    roleid: "캐릭터id",
    pay_title: "결제방식",
    money: "전액결제",
    order_id: "주문번호",
    pay_time: "시간",
    coupon_code: "코드",
    all_ratio: "증정 비율",
    button: {
        back: "리턴",
        againRecahrge: "추가 결제"
    }
}